// Speed Parts — scripts propios (prefijo sp-)

function initReveals() {
  var els = document.querySelectorAll('.sp-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('sp-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-sp-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('sp-visible');
          }, parseInt(delay, 10));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initProductGallery() {
  var main = document.querySelector('[data-sp-main-image]');
  var thumbs = document.querySelectorAll('[data-sp-thumb]');
  if (!main || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-sp-full');
      main.querySelector('img').setAttribute('src', fullSrc);
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

function initProductVariants() {
  var form = document.querySelector('[data-sp-product-form]');
  if (!form) return;

  var dataEl = form.querySelector('[data-sp-variants-json]');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);

  var selects = form.querySelectorAll('[data-sp-option-select]');
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-sp-price]');
  var addBtn = form.querySelector('[data-sp-add-btn]');
  var stockEl = document.querySelector('[data-sp-stock]');

  function currentSelection() {
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  function findVariant() {
    var selection = currentSelection();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (variant.available) {
      addBtn.disabled = false;
      addBtn.textContent = addBtn.getAttribute('data-sp-label-add');
      if (stockEl) { stockEl.textContent = stockEl.getAttribute('data-sp-label-instock'); stockEl.classList.remove('is-out'); }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.getAttribute('data-sp-label-soldout');
      if (stockEl) { stockEl.textContent = stockEl.getAttribute('data-sp-label-outstock'); stockEl.classList.add('is-out'); }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
}

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initProductGallery();
  initProductVariants();
});
